export default __webpack_public_path__ + "static/Martin_with_name-886a30809fb6747f5107f6b1b937dd39.png";